import { cx } from '../lib/cx';

/**
 * The Seth Dive Mexico wordmark. White on the deep blue rail; on light backgrounds the same
 * artwork is used as a mask and filled with deep blue.
 */
export function Logo({ tone = 'white', width = 164, className }: { tone?: 'white' | 'deep'; width?: number; className?: string }) {
  const height = Math.round((width * 437) / 1182);
  if (tone === 'white') {
    return <img src="/seth-dive-logo.png" alt="Seth Dive Mexico" width={width} height={height} className={cx('block', className)} />;
  }
  return (
    <span
      role="img"
      aria-label="Seth Dive Mexico"
      className={cx('block bg-deep', className)}
      style={{
        width,
        height,
        maskImage: 'url(/seth-dive-logo.png)',
        WebkitMaskImage: 'url(/seth-dive-logo.png)',
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
      }}
    />
  );
}
